import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/vehicles';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(id) {
    const url = `${this.baseUrl}/${id}`;
    return await fetchWrapper.get(url);
  }

  static async findDrivers(filters) {
    const url = `${this.baseUrl}/drivers?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOwners(filters) {
    const url = `${this.baseUrl}/owners?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects(filters) {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async update(form) {
    return await fetchWrapper.patch(this.baseUrl, form);
  }

  static async updateStatus(form) {
    const url = `${this.baseUrl}/status`;
    return await fetchWrapper.patch(url, form);
  }

  static async destroy(id) {
    return await fetchWrapper.delete(this.baseUrl, { id });
  }
}
